import { DOCTOR_ME } from '@medical/layout/DoctorLayout/DoctorLayoutRequest.graphql'

export const checkDoctorBlocked = ({ client }) => {
  const { doctorMe } = client.readQuery({
    query: DOCTOR_ME,
  })
  const { blocked } = doctorMe
  return blocked
}
